import OperatorPrivilegesStateInterface from "../../interfaces/OperatorPrivilegesStateInterface";

const defaultPrivileges: OperatorPrivilegesStateInterface = {
  notFound: false,
  loadFailed: false,
  data: null,
};

export const operatorPrivileges = (
  state: OperatorPrivilegesStateInterface = defaultPrivileges,
  action: ReduxActions.Action<any>,
): OperatorPrivilegesStateInterface => {
  switch (action.type) {
    case "GET_OPERATOR_PRIVILEGES_REQUESTED":
      return { ...state, loadFailed: false };
    case "GET_OPERATOR_PRIVILEGES_RESPONSE_RECEIVED":
      return {
        data: action.payload.operator,
        notFound: false,
        loadFailed: false,
      };
    case "GET_OPERATOR_PRIVILEGES_RESPONSE_ERROR":
      if (action.payload && action.payload.status === 404) {
        return {
          ...state,
          notFound: true,
          loadFailed: true,
        };
      }
      return { ...state, loadFailed: true };
    default:
      return state;
  }
};
